import React, { useEffect, useState } from 'react';
import { fetchAuthSession, signOut } from 'aws-amplify/auth';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import { ENV } from '../../../constants';

export const LOGIN_CLOSED_TITLE = '週報APPは新環境へ移行しました';
export const LOGIN_CLOSED_MESSAGE =
  'このURLからはログインできません。以下の新しいアプリをご利用ください。';
export const LOGIN_CLOSED_MESSAGE_NO_URL =
  'このURLからはログインできません。移行先のアプリは後日公開いたします。';

// アプリ環境移行に伴うログイン封鎖画面。
// ログインフォームは描画せず、ログイン済みユーザーは自動的にログアウトして新アプリへ誘導する
const LoginClosedGate: React.FC = () => {
  const [signingOut, setSigningOut] = useState(true);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        // ログイン済み（トークンあり）の場合のみ、端末のトークンに加え Cognito 側のリフレッシュトークンも失効させる
        const { tokens } = await fetchAuthSession();
        if (tokens) {
          await signOut({ global: true });
        }
      } catch {
        // 失効に失敗した場合は端末側のみサインアウトして続行する
        try {
          await signOut();
        } catch {
          // 何もできない場合も案内画面は表示する
        }
      } finally {
        if (!cancelled) setSigningOut(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  // 環境変数が未設定・未入力（空白のみ含む）の場合は URL を表示しない
  const newAppUrl = (ENV.NEW_APP_URL ?? '').trim();

  if (signingOut) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <div className="weeklySignInPage">
      <div className="weeklySignInHeader">
        <div className="weeklySignInIconWrap" aria-hidden="true">
          <DescriptionOutlinedIcon className="weeklySignInIcon" />
        </div>
        <p className="weeklySignInBrand">Weekly Report App</p>
        <h1 className="weeklySignInTitle">{LOGIN_CLOSED_TITLE}</h1>
        <span className="weeklySignInTitleBar" aria-hidden="true" />
      </div>
      <div style={{ textAlign: 'center', maxWidth: 600, padding: '0 16px' }}>
        <p data-testid="login-closed-message">
          {newAppUrl ? LOGIN_CLOSED_MESSAGE : LOGIN_CLOSED_MESSAGE_NO_URL}
        </p>
        {newAppUrl && (
          <p>
            <a
              href={newAppUrl}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="login-closed-link"
            >
              {newAppUrl}
            </a>
          </p>
        )}
      </div>
    </div>
  );
};

export default LoginClosedGate;
